import React, { useEffect } from "react";
import Icon from "../../icons";
import ReactTooltip from "react-tooltip";
import Breadcrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import { useState } from "react";
import Table from "../../common/table";
import CS from "../../../services/commonService";
import {
	useGetCoreReportTypes,
	useGetReportReasons,
	useUpdateReportReasons,
} from "../../../queryHooks";
import qs from "qs";
import SingleStatusToggle from "../../common/singleStatusToggle";
import Modal from "../../common/Modal";
import AddUpdate from "./AddUpdate";
import { useStore } from "../../../zustand/store";

const columnKey = "reportReasons";

const ReportReasons = () => {
	const setLoading = useStore((state) => state.setLoading);
	const [tableData, setTableData] = useState([]);
	const [pageNow, setPageNow] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [open, setOpen] = useState(false);
	const [item, setItem] = useState();
	const [payload, setPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
	});
	const [typesOptions, setTypesOptions] = useState([]);

	const { data: coreReportTypes } = useGetCoreReportTypes();
	useEffect(() => {
		if (coreReportTypes?.status === "success") {
			let options = [];
			coreReportTypes?.data?.reporting_types?.forEach((element) => {
				options.push({ label: element?.label, value: element?.code });
			});
			setTypesOptions(options);
		}
	}, [coreReportTypes]);

	const {
		data: reportReasonsData,
		isLoading,
		refetch,
	} = useGetReportReasons(qs.stringify(payload));

	useEffect(() => {
		if (reportReasonsData?.status === "success") {
			let respData = reportReasonsData?.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [reportReasonsData]);

	const {
		mutateAsync: updateReportReasonsApi,
		error: errorUpdateReason,
		data: updateReasonData,
		isLoading: updateReasonLoading,
	} = useUpdateReportReasons();

	useEffect(() => {
		if (updateReasonData) {
			if (updateReasonData.status === "success") {
				CS.showSuccessMessage(updateReasonData.message);
				refetch();
			} else if (updateReasonData.status === "fail") {
				CS.showErrorMessage(updateReasonData.message);
			}
		}
	}, [updateReasonData]);

	useEffect(() => {
		if (errorUpdateReason) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateReason?.response?.data?.message);
		}
	}, [errorUpdateReason]);

	useEffect(() => {
		setLoading(updateReasonLoading);
	}, [updateReasonLoading]);

	const columns = [
		{
			label: "Reason",
			type: "string",
			sort: true,
			path: "core_report_reasons.label",
			alias: "core_report_reasons.label",
			content: (item) => <p>{item?.label}</p>,
		},
		{
			label: "Description",
			type: "string",
			path: "description",
			alias: "description",
			content: (item) => <p>{item?.description}</p>,
		},
		{
			label: "Type",
			type: "string",
			path: "type",
			aliasFilter: "core_report_types.code",
			filterOptions: typesOptions,
			content: (item) => (
				<p>
					{item?.report_types?.map(
						(type, index) =>
							`${type.label}${
								index + 1 !== item?.report_types?.length ? ", " : ""
							}`
					)}
				</p>
			),
		},
		{
			label: "Status",
			type: "boolean",
			aliasFilter: "is_active",
			filterOptions: [
				{ label: "Active", value: 1 },
				{ label: "Inactive", value: 0 },
			],
			content: (item) => (
				<SingleStatusToggle
					_id={item?.id}
					status={item?.is_active == 1 ? true : false}
					onToggleChange={() => {
						let report_types = item?.report_types?.map((val) => val.code);
						updateReportReasonsApi({
							reasonId: item?.id,
							body: {
								is_active: !item?.is_active,
								report_types,
							},
						});
					}}
					htmlFor={item?.id}
				/>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="edit"
						data-tip
						data-for="edit"
						onClick={() => {
							setItem(item);
							setOpen(true);
						}}
					/>
					<ReactTooltip id="edit">Edit</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<Breadcrumbs
				title="Content Reporting"
				data={[{ label: "Report Reasons" }]}
			/>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												searchValue={""}
												search={(value) => {
													setPageNow(1);
													setPayload({
														...payload,
														search: {
															"core_report_reasons.label":
																!value && value === "" ? undefined : value,
															description:
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												onClick={() => {
													setItem(null);
													setOpen(true);
												}}
												id="addNewReason"
												type="button"
												className="btn glow-primary btn-primary"
											>
												<i className="bx bx-user-plus d-lg-none" />
												<span className="d-none d-sm-none d-lg-inline-block">
													Add Reason
												</span>
											</button>
											{/* <Download columnKey={columnKey} /> */}
										</div>
									</div>
								</div>
							</div>
							<Modal open={open} onCloseModal={() => setOpen(false)}>
								<AddUpdate
									item={item}
									onSuccessRefetch={() => {
										refetch();
										setOpen(false);
									}}
								/>
							</Modal>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								payload={payload}
								sortCol={(obj) => {
									setPageNow(1);
									setPayload({
										...payload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setPayload({
										...payload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setPayload({
										...payload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = CS.filterData(payload.filter, obj);
										setPageNow(1);
										setPayload({
											...payload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setPayload({
											...payload,
											filter: {
												...payload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setPayload({
										...payload,
										filter_date: dates && {
											...payload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ReportReasons;
